import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/chat.svg';

export const IconChat = createIconComponent(Icon);
